// Spell records saved before the SRD 5.2 catalog (October 2025) copied damage dice and upcast text from the
// 2014 catalog (for example Inflict Wounds 3d10, Flame Strike 4d6). When a record names a spell that is in the
// current catalog, its dice and cantrip scaling come from the catalog, and stored upcast text is replaced by the
// catalog's. Damage-type words kept after the dice stay. Records for spells missing from the catalog are unchanged.
const DICE = /\d+d\d+(?:\s*[+-]\s*\d+)?/;

export const withCatalogDice = (spell, catalogByName = {}) => {
  const catalog = catalogByName[String(spell?.name || '').trim().toLowerCase()];
  if (!spell || !catalog?.damage) return spell;
  const stored = typeof spell.damage === 'string' ? spell.damage : '';
  const damage = DICE.test(stored) ? stored.replace(DICE, catalog.damage) : catalog.damage;
  return {
    ...spell,
    damage,
    higherLevels: spell.higherLevels ? catalog.higherLevels ?? spell.higherLevels : spell.higherLevels,
    scaling: catalog.scaling ?? spell.scaling,
  };
};
